// extracted by mini-css-extract-plugin
export default {"aside-controller":"AsideRightControllerIcon_aside-controller__+nZC9","icon":"AsideRightControllerIcon_icon__zyqxq","icon--selected":"AsideRightControllerIcon_icon--selected__tAAzN"};